/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageSummarySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageSummarySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageSummarySecurity = {
  option1?: GetToolUsageSummarySecurityOption1 | undefined;
  option2?: GetToolUsageSummarySecurityOption2 | undefined;
};

export type GetToolUsageSummaryRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageSummarySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageSummarySecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolUsageSummarySecurityOption1$Outbound,
  GetToolUsageSummarySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolUsageSummarySecurityOption1ToJSON(
  getToolUsageSummarySecurityOption1: GetToolUsageSummarySecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageSummarySecurityOption1$outboundSchema.parse(
      getToolUsageSummarySecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageSummarySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageSummarySecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolUsageSummarySecurityOption2$Outbound,
  GetToolUsageSummarySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolUsageSummarySecurityOption2ToJSON(
  getToolUsageSummarySecurityOption2: GetToolUsageSummarySecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageSummarySecurityOption2$outboundSchema.parse(
      getToolUsageSummarySecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageSummarySecurity$Outbound = {
  Option1?: GetToolUsageSummarySecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageSummarySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageSummarySecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageSummarySecurity$Outbound,
  GetToolUsageSummarySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageSummarySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageSummarySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageSummarySecurityToJSON(
  getToolUsageSummarySecurity: GetToolUsageSummarySecurity,
): string {
  return JSON.stringify(
    GetToolUsageSummarySecurity$outboundSchema.parse(
      getToolUsageSummarySecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageSummaryRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageSummaryRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageSummaryRequest$Outbound,
  GetToolUsageSummaryRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageSummaryRequestToJSON(
  getToolUsageSummaryRequest: GetToolUsageSummaryRequest,
): string {
  return JSON.stringify(
    GetToolUsageSummaryRequest$outboundSchema.parse(getToolUsageSummaryRequest),
  );
}
